"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconImportantComment = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M22,2 L2,2 L2,22 L6,18 L22,18 L22,2 Z M13,14 L11,14 L11,12 L13,12 L13,14 Z M13,10 L11,10 L11,6 L13,6 L13,10 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconImportantComment')(IconImportantComment);